module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-tra-ab5f2ea8483b04e7e1ad937f1b7355b4.png";